function Footer() {
  this.node = null
  this.$node = null

  this.$node = $(".marketing-footer-navigation")
  var activeClass = "marketing-footer-navigation--active"
  var listClass = "marketing-footer-navigation__list"
  var headingClass = "marketing-footer-navigation__list-heading"
  var linkClass = "marketing-footer-navigation__link"
  var $toggleButton = this.$node.find("." + headingClass)
  var $toggleTarget = this.$node.find("." + listClass)
  var $mobileLink = $("." + linkClass)

  $toggleButton.on("click", function(event) {
    var $currentNav = $(this).closest($toggleTarget)
    if ($currentNav.hasClass(activeClass)) {
      $currentNav.removeClass(activeClass)
    } else {
      $toggleTarget.removeClass(activeClass)
      $currentNav.addClass(activeClass)
    }
  })
  $mobileLink.on("focus", function() {
    var $currentNav = $(this).closest($toggleTarget)
    var $otherNavs = $currentNav.siblings($toggleTarget)
    $currentNav.addClass(activeClass)
    $otherNavs.removeClass(activeClass)
  })
}
